// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.crDcPRQ4FHiI6V_Rad_L>tr{color:#99adb2;text-align:center}.crDcPRQ4FHiI6V_Rad_L>tr>td{vertical-align:middle}`, "",{"version":3,"sources":["webpack://./ui-kit/Table/TableHead/TableHead.module.scss"],"names":[],"mappings":"AAEI,yBACE,aAAA,CACA,iBAAA,CAEE,4BACE,qBAAA","sourcesContent":[".tableHead {\r\n  > {\r\n    tr {\r\n      color: #99adb2;\r\n      text-align: center;\r\n      > {\r\n        td {\r\n          vertical-align: middle;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableHead": `crDcPRQ4FHiI6V_Rad_L`
};
export default ___CSS_LOADER_EXPORT___;
